import { useCallback, useState } from 'react';
import { useGetChatSessionsProcessingQuery } from 'services';
import { FindAllChatSessions, UseQueryOptionsType } from 'types';
import { DEFAULT_PAGE_SIZE } from 'utils';
const pageSize = DEFAULT_PAGE_SIZE;
export function useOmniChatSessionsProcessingList(
  params: Omit<FindAllChatSessions, 'skip' | 'limit'>,
  options?: UseQueryOptionsType
) {
  const { keyword, endpoint } = params;

  const [skip, setSkip] = useState(0);

  const {
    data: dataResponse,
    isLoading,
    isFetching,
    refetch
  } = useGetChatSessionsProcessingQuery(
    {
      skip,
      limit: pageSize,
      keyword,
      endpoint
    },
    {
      ...options,
      refetchOnMountOrArgChange: true
    }
  );

  const { rows, count } = dataResponse?.data || {};

  const hasMore = Boolean(rows && count && rows.length < count);

  const handleLoadMore = useCallback(() => {
    if (hasMore && !isFetching) {
      setSkip(rows?.length ?? 0);
    }
  }, [hasMore, skip, isFetching]);

  const resetPage = () => {
    setSkip(0);
  };

  return {
    chatSessionProcessing: rows || [],
    count: count || 0,
    isFetching,
    isLoading,
    handleLoadMore,
    hasMore,
    resetPage,
    refetch
  };
}
